<template>
    <div class="segment-tab flex items-center justify-center bg-white rounded-full p-1">
        <div
            v-for="(item, idx) in items"
            :key="`segment-${idx}`"
            class="flex-1 min-w-0 px-3 py-1 text-sm text-center capitalize truncate rounded-full cursor-pointer"
            :class="isActive(idx) ? 'text-white segment-tab__active' : 'text-gray-1'"
            @click="select(idx)"
        >{{ item }}</div>
    </div>
</template>
<script>
export default {
    name: "SegmentTab",
    props: {
        modelValue: {
            type: Number,
            default: 0,
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    emits: ["update:modelValue"],
    methods: {
        isActive: function (idx) {
            return idx == this.modelValue;
        },
        select: function (idx) {
            if (idx == this.modelValue) return;
            this.$emit("update:modelValue", idx);
        },
    },
};
</script>
<style lang="scss" scoped>
.segment-tab {
    max-width: 500px;
    margin: auto;
    box-shadow: 0px 4px 4px #e0efff;

    &__active {
        background-image: linear-gradient(to right, #1c2c73, #016cb8);
    }
}
</style>
